interface TypographyStyle {
  fontSize: string;
  fontWeight: number;
  lineHeight: string;
  letterSpacing: string;
}

interface TypographyHeadline {
  md: TypographyStyle;
  sm: TypographyStyle;
  xs: TypographyStyle;
}

interface TypographyEnglishBody {
  lg: {
    semibold: TypographyStyle;
    regular: TypographyStyle;
  };
  md: {
    semibold: TypographyStyle;
    regular: TypographyStyle;
  };
  sm: {
    semibold: TypographyStyle;
    regular: TypographyStyle;
  };
  xs: {
    semibold: TypographyStyle;
    regular: TypographyStyle;
  };
  xxs: {
    regular: TypographyStyle;
  };
}

interface TypographyArabicBody {
  lg: {
    bold: TypographyStyle;
    regular: TypographyStyle;
  };
  md: {
    bold: TypographyStyle;
    regular: TypographyStyle;
  };
  sm: {
    bold: TypographyStyle;
    regular: TypographyStyle;
  };
  xs: {
    bold: TypographyStyle;
    regular: TypographyStyle;
  };
  xxs: {
    regular: TypographyStyle;
  };
}

interface TypographyLanguage<TBody> {
  fontFamily: string;
  variants: {
    headline: TypographyHeadline;
    body: TBody;
  };
}

export interface Typography {
  english: TypographyLanguage<TypographyEnglishBody>;
  arabic: TypographyLanguage<TypographyArabicBody>;
}

export const typography: Typography = {
  english: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    variants: {
      headline: {
        md: {
          fontSize: "24px",
          fontWeight: 600,
          lineHeight: "32px",
          letterSpacing: "0px",
        },
        sm: {
          fontSize: "20px",
          fontWeight: 600,
          lineHeight: "28px",
          letterSpacing: "0px",
        },
        xs: {
          fontSize: "18px",
          fontWeight: 600,
          lineHeight: "24px",
          letterSpacing: "0px",
        },
      },
      body: {
        lg: {
          semibold: {
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "22px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "22px",
            letterSpacing: "0px",
          },
        },
        md: {
          semibold: {
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "20px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0px",
          },
        },
        sm: {
          semibold: {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "18px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            letterSpacing: "0px",
          },
        },
        xs: {
          semibold: {
            fontSize: "11px",
            fontWeight: 600,
            lineHeight: "16px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "11px",
            fontWeight: 400,
            lineHeight: "16px",
            letterSpacing: "0px",
          },
        },
        xxs: {
          regular: {
            fontSize: "10px",
            fontWeight: 400,
            lineHeight: "14px",
            letterSpacing: "0px",
          },
        },
      },
    },
  },
  arabic: {
    fontFamily: "Almarai",
    variants: {
      headline: {
        md: {
          fontSize: "24px",
          fontWeight: 700,
          lineHeight: "32px",
          letterSpacing: "0px",
        },
        sm: {
          fontSize: "20px",
          fontWeight: 700,
          lineHeight: "28px",
          letterSpacing: "0px",
        },
        xs: {
          fontSize: "18px",
          fontWeight: 700,
          lineHeight: "24px",
          letterSpacing: "0px",
        },
      },
      body: {
        lg: {
          bold: {
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "22px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "22px",
            letterSpacing: "0px",
          },
        },
        md: {
          bold: {
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: "20px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0px",
          },
        },
        sm: {
          bold: {
            fontSize: "12px",
            fontWeight: 700,
            lineHeight: "18px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            letterSpacing: "0px",
          },
        },
        xs: {
          bold: {
            fontSize: "11px",
            fontWeight: 700,
            lineHeight: "16px",
            letterSpacing: "0px",
          },
          regular: {
            fontSize: "11px",
            fontWeight: 400,
            lineHeight: "16px",
            letterSpacing: "0px",
          },
        },
        xxs: {
          regular: {
            fontSize: "10px",
            fontWeight: 400,
            lineHeight: "14px",
            letterSpacing: "0px",
          },
        },
      },
    },
  },
};
